import * as React from 'react'

export const HeadingOneIcon = React.memo(({
  className,
  ...props
}) => {
  return (
    <svg
      width='24'
      height='24'
      className={className}
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M20.7446 20.6997H18.2551V13.8838L18.2793 12.7639L18.3196 11.5393C17.906 11.9529 17.6187 12.2241 17.4575 12.353L16.104 13.4407L14.9036 11.9421L18.6982 8.9209H20.7446V20.6997Z'
        fill='currentColor'
      />
      <path
        d='M3.42871 2.69971V9.44971H9.42871V2.69971H12.4287V20.6997H9.42871V12.8247H3.42871V20.6997H0.428711V2.69971H3.42871Z'
        fill='currentColor'
      />
    </svg>
  )
})

HeadingOneIcon.displayName = 'HeadingOneIcon'
